import { Close, Search } from '@mui/icons-material'
import { Box, CircularProgress, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import AdxCheckbox from 'components/custom/AdxCheckbox'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxInput from 'components/custom/AdxInput'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import { Field, Form, Formik } from 'formik'
import EmployeeList from 'module/payroll/global-components/EmployeeList'
import React, { useEffect, useRef, useState } from 'react'
import AdxActionButton from 'components/reusable/ActionButton/AdxActionButton'
import AdxButton from 'components/custom/AdxButton'

const SelectEmployeeModal = ({
  details,
  children,
  itemDescription,
  item,
  handleAllEmployees,
  handleSelectedEmployees,
  loadingSelectedStatus,
  loadingAllStatus,
  titleHeader,
  descHeader,
  iconHeader,
}) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [value, setValue] = useState('all')
  const formikRef = useRef()

  // to get loading state for download and send all
  const [isLoadingAll, setIsLoadingAll] = useState(false)
  useEffect(() => {
    setIsLoadingAll(loadingAllStatus)
  }, [loadingAllStatus])

  const handleOpen = () => {
    setModalOpen(true)
  }
  const handleClose = () => {
    setModalOpen(false)
    setValue('all')
  }

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }
  const control = {
    value: value,
    onChange: handleChange,
    exclusive: true,
  }
  const toggleStyle = () => {
    return {
      '&.Mui-selected': {
        color: 'alternate.main',
        backgroundColor: 'alternate.light',
        border: 1,
        '&.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
          borderLeft: 1,
        },
      },
      '&:hover': {
        color: 'alternate.main',
        backgroundColor: 'gray-background.main',
      },
    }
  }
  const handleSubmission = (values) => {
    let selected_employee = values
      ?.filter((item) => {
        if (item.checked) {
          return item
        } else {
          return null
        }
      })
      .map((item) => {
        const { employee_id, checked } = item
        return { employee_id, checked }
      })
    let data = { selected_employee }
    handleSelectedEmployees(data)
  }

  return (
    <>
      <Box onClick={handleOpen}>{children}</Box>
      <AdxFormModal
        open={isModalOpen}
        onClose={handleClose}
        handleClose={handleClose}
        sxModal={{ maxHeight: '90vh' }}
        customHeader={
          <AdxActionButton
            sx={{
              boxShadow: 'none',
              border: 'none',
              boxSizing: 'border-box',
              px: 3,
            }}
            title={titleHeader}
            description={descHeader}
            icon={iconHeader}
            sxIcon={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            iconColor="alternate.main"
            iconBgColor="alternate.light"
          />
        }
      >
        <Formik
          innerRef={formikRef}
          initialValues={details?.map((items) => ({
            employee_id: items.id,
            data: items,
            checked: false,
          }))}
          onSubmit={handleSubmission}
        >
          {({ values, setFieldValue, handleSubmit }) => {
            let employeeChecked = values?.filter((items) => {
              if (items.checked === true) {
                return items
              } else {
                return null
              }
            })
            return (
              <Form>
                <Box sx={{ px: 1 }}>
                  <Typography color="light-gray-text.main">{itemDescription}</Typography>
                  <ToggleButtonGroup fullWidth {...control} sx={{ my: 2 }}>
                    <ToggleButton value="all" key="all" sx={{ ...toggleStyle() }}>
                      All employees
                    </ToggleButton>
                    <ToggleButton value="selected" key="selected" sx={{ ...toggleStyle() }}>
                      Selected employee(s)
                    </ToggleButton>
                  </ToggleButtonGroup>
                  {value === 'selected' && (
                    <AdxTabsBadge whiteBackground>
                      <AdxTabsPanel label="Employee">
                        <AdxInput
                          placeholder="Search for employee to add"
                          onChange={(e) => setSearchTerm(e.target.value)}
                          fullWidth
                          value={searchTerm}
                          sx={{
                            my: 1,
                            '& .MuiInputBase-root': {
                              minHeight: '35px',
                              outlineColor: '#E5E5E5',
                            },
                            '&.MuiBox-root': {
                              bgcolor: 'white.main',
                              width: 'auto',
                            },
                          }}
                          startAdornment={<Search color="light-gray-text" sx={{ mr: 1 }} />}
                          endAdornment={
                            searchTerm && (
                              <Close
                                color="alternate"
                                onClick={() => setSearchTerm('')}
                                sx={{ cursor: 'pointer' }}
                              />
                            )
                          }
                        />

                        <Box
                          display="flex"
                          flexDirection="column"
                          height="calc(100vh - 80vh)"
                          overflow="auto"
                        >
                          {values
                            ?.filter((item) => {
                              if (searchTerm === '') {
                                return item
                              } else if (
                                item.data.name.toLowerCase().includes(searchTerm.toLowerCase())
                              ) {
                                return item
                              } else {
                                return null
                              }
                            })
                            .map((list, index) => {
                              return (
                                <Field
                                  // name={`${index}.checked`}
                                  as={AdxFormControlLabel}
                                  onChange={(e) => {
                                    setFieldValue(
                                      `${values.findIndex(
                                        (val) => val.employee_id === list.employee_id
                                      )}.checked`,
                                      e.target.checked
                                    )
                                  }}
                                  type="no-fill"
                                  key={index}
                                  control={<AdxCheckbox />}
                                  checked={
                                    values.find((val) => val.employee_id === list.employee_id)
                                      .checked
                                  }
                                  label={
                                    <EmployeeList
                                      avatar={list.data.avatar}
                                      sxAvatar={{
                                        width: '30px',
                                        height: '30px',
                                      }}
                                      name={list.data.name}
                                      position={list.data.position}
                                    />
                                  }
                                />
                              )
                            })}
                        </Box>
                      </AdxTabsPanel>
                      <AdxTabsPanel label={`Selected (${employeeChecked?.length})`}>
                        <Box
                          display="flex"
                          flexDirection="column"
                          height="calc(100vh - 80vh)"
                          overflow="auto"
                          sx={{ mt: 2 }}
                        >
                          {employeeChecked?.map((list, index) => {
                            return (
                              <Field
                                as={AdxFormControlLabel}
                                type="no-fill"
                                key={index}
                                control={<AdxCheckbox />}
                                checked
                                onChange={(e) => {
                                  setFieldValue(
                                    `${values.findIndex(
                                      (val) => val.employee_id === list.employee_id
                                    )}.checked`,
                                    e.target.checked
                                  )
                                }}
                                label={
                                  <EmployeeList
                                    avatar={list.data.avatar}
                                    sxAvatar={{ width: '30px', height: '30px' }}
                                    name={list.data.name}
                                    position={list.data.position}
                                  />
                                }
                              />
                            )
                          })}
                        </Box>
                      </AdxTabsPanel>
                    </AdxTabsBadge>
                  )}
                  <Box
                    sx={{ mt: value === 'selected' ? 1 : 6 }}
                    display="flex"
                    justifyContent="center"
                    columnGap={1}
                    width="100%"
                  >
                    <AdxButton
                      variant={'ghost'}
                      onClick={handleClose}
                      sx={{ width: 'calc(100% * 1 / 3)' }}
                    >
                      Cancel
                    </AdxButton>
                    {value === 'all' ? (
                      isLoadingAll ? (
                        <AdxButton variant={'contained'} sx={{ width: 'calc(100% * 2 / 3)' }}>
                          <CircularProgress color="white" size={20} />
                        </AdxButton>
                      ) : (
                        <AdxButton
                          variant={'contained'}
                          onClick={handleAllEmployees}
                          sx={{ width: 'calc(100% * 2 / 3)' }}
                        >{`${item} (All)`}</AdxButton>
                      )
                    ) : employeeChecked?.length === 0 ? (
                      <AdxButton
                        variant={'contained'}
                        disabled
                        sx={{ width: 'calc(100% * 2 / 3)' }}
                      >{`${item} `}</AdxButton>
                    ) : loadingSelectedStatus ? (
                      <AdxButton variant={'contained'} sx={{ width: 'calc(100% * 2 / 3)' }}>
                        <CircularProgress color="white" size={20} />
                      </AdxButton>
                    ) : (
                      <AdxButton
                        variant={'contained'}
                        onClick={() => handleSubmit()}
                        sx={{ width: 'calc(100% * 2 / 3)' }}
                      >{`${item} (${employeeChecked?.length})`}</AdxButton>
                    )}
                  </Box>
                </Box>
              </Form>
            )
          }}
        </Formik>
      </AdxFormModal>
    </>
  )
}
export default SelectEmployeeModal
